import React from 'react';
import { ReverseRotate } from '../reverse-rotate';
import { BaseLabel } from '../base-label';
import { GenericIcon } from '../icon/generic-icon';
import { round } from '../../utils/utils';
import { IconPosition } from '../../interfaces';
import { LABEL_FONT_SIZE, LABEL_LINE_HEIGHT } from '../../constants';
var ICON_SIZE = 24;
var ICON_OFFSET = -5;
var TEXT_HEIGHT = LABEL_FONT_SIZE * LABEL_LINE_HEIGHT;
var TEXT_OFFSET = 5;
export var LabelWithIcon = function (_a) {
    var _b = _a.definition, width = _b.width, height = _b.height, text = _b.text, _c = _b.angle, angle = _c === void 0 ? 0 : _c, color = _b.color, icon = _b.icon, iconPosition = _b.iconPosition;
    var midX = round(width / 2);
    var midY = round(height / 2);
    var _d = getPositions({
        midY: midY,
        midX: midX,
        icon: icon,
        iconPosition: iconPosition,
        text: text,
    }), iconX = _d.iconX, iconY = _d.iconY, labelY = _d.labelY;
    return (React.createElement("svg", { width: width, height: height },
        React.createElement(ReverseRotate, { rotateX: midX, rotateY: midY, angle: angle },
            text ? (React.createElement(BaseLabel, { color: color, y: labelY }, text)) : null,
            icon ? React.createElement(GenericIcon, { x: iconX, y: iconY, type: icon, size: ICON_SIZE, fill: color }) : null)));
};
var getPositions = function (_a) {
    var midY = _a.midY, midX = _a.midX, icon = _a.icon, text = _a.text, iconPosition = _a.iconPosition;
    var iconX, labelY, iconY;
    if (icon && text) {
        iconX = round(midX - ICON_SIZE / 2, 1);
        if (iconPosition === IconPosition.bottom) {
            labelY = round(midY - TEXT_HEIGHT / 2 - TEXT_OFFSET, 1);
            iconY = round(midY + ICON_OFFSET, 1);
        }
        else {
            labelY = round(midY + TEXT_HEIGHT / 2 + TEXT_OFFSET, 1);
            iconY = round(midY - ICON_SIZE - ICON_OFFSET, 1);
        }
    }
    else if (icon) {
        iconY = round(midY - ICON_SIZE / 2, 1);
        iconX = round(midX - ICON_SIZE / 2, 1);
    }
    return { iconX: iconX, labelY: labelY, iconY: iconY };
};
//# sourceMappingURL=label-with-icon.js.map